module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/propertyPins-home-default-e691903c4b96edb3b762da6fd47d87a3.png";